import React, { useEffect } from "react";
import { useState } from "react";
import Gallery from "../Gallery/Gallery";
import CompanyHistory from "./CompanyHistory";
import CompanyStaff from "./CompanyStaff";
import { teamMembersDatas } from "../../../constants";
import TeamMembers from "./TeamMembers";

const AboutInfo = () => {
  const [informations, setInformations] = useState([]);
  const [members, setMembers] = useState([])

  useEffect(() => {
    fetch("aboutUs.json")
      .then((res) => res.json())
      .then((data) => setInformations(data));
  }, []);

  useEffect(() => {
    fetch("aboutUsMembers.json")
      .then((res) => res.json())
      .then((data) => setMembers(data));
  }, []);

  return (
    <div>
      <div>
        {informations.map((information) => (
          <CompanyHistory
            key={information._id}
            information={information}
          />
        ))}
      </div>
      <div>
        {members.map((member) => (
          <CompanyStaff
            key={member.id}
            member={member}
          />
        ))}
      </div>
      <div>
        {teamMembersDatas.map((teamMembersData)=> (
          <TeamMembers
          key={teamMembersData.id}
          aboutUsMembersData={teamMembersData}
          />
        ))}
      </div>
      <div>
        <h2 className='font-bold text-3xl py-2 text-center'>Team Members</h2>
        <div className="grid gap-x-6 md:grid-cols-3 lg:gap-x-12">
      <div className="mb-6 lg:mb-0">
        <div
          className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">

            
          <div className="relative overflow-hidden bg-cover bg-no-repeat">
            <img src="https://mdbcdn.b-cdn.net/img/new/avatars/6.jpg" className="w-full rounded-t-lg" />
            <a href="#!">
              <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
            </a>
            <svg className="absolute text-white dark:text-neutral-700 left-0 bottom-0" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 320">
              <path fill="currentColor"
                d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>


          <div className="p-6">
            <h5 className="mb-4 text-lg font-bold">Maria Smith</h5>
            <p className="mb-4 text-neutral-500 dark:text-neutral-300">Frontend Developer</p>
          </div>
        </div>
      </div>


      <div className="mb-6 lg:mb-0">
        <div
          className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
          <div className="relative overflow-hidden bg-cover bg-no-repeat">
            <img src="https://mdbcdn.b-cdn.net/img/new/avatars/8.jpg" className="w-full rounded-t-lg" />
            <a href="#!">
              <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
            </a>
            <svg className="absolute text-white dark:text-neutral-700  left-0 bottom-0" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 320">
              <path fill="currentColor"
                d="M0,96L48,128C96,160,192,224,288,240C384,256,480,224,576,213.3C672,203,768,213,864,202.7C960,192,1056,160,1152,128C1248,96,1344,64,1392,48L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="p-6">
            <h5 className="mb-4 text-lg font-bold">Darren Randolph</h5>
            <p className="mb-4 text-neutral-500 dark:text-neutral-300">Marketing expert</p>
          </div>
        </div>
      </div>

      <div className="">
        <div
          className="block rounded-lg bg-white shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
          <div className="relative overflow-hidden bg-cover bg-no-repeat">
            <img src="https://mdbcdn.b-cdn.net/img/new/avatars/15.jpg" className="w-full rounded-t-lg" />
            <a href="#!">
              <div className="absolute top-0 right-0 bottom-0 left-0 h-full w-full overflow-hidden bg-fixed"></div>
            </a>
            <svg className="absolute text-white dark:text-neutral-700 left-0 bottom-0" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 320">
              <path fill="currentColor"
                d="M0,288L48,256C96,224,192,160,288,160C384,160,480,224,576,213.3C672,203,768,117,864,85.3C960,53,1056,75,1152,69.3C1248,64,1344,32,1392,16L1440,0L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="p-6">
            <h5 className="mb-4 text-lg font-bold">Ayat Black</h5>
            <p className="mb-4 text-neutral-500 dark:text-neutral-300">Web designer</p>
          </div>
        </div>
      </div>
    </div>
      </div>
      <br />

      
      <div>
        <h1 className='font-bold text-3xl py-2 text-center'>Happy CLients</h1>

        <div
          id="fullWidthTabContent"
          className="border-t border-gray-200 dark:border-gray-600"
        >
          <div
            className="p-4 bg-white rounded-lg md:p-8 dark:bg-gray-800"
            id="stats"
            role="tabpanel"
            aria-labelledby="stats-tab"
          >
            <dl className="grid max-w-screen-xl grid-cols-1 gap-8 p-4 mx-auto text-gray-900 sm:grid-cols-3 xl:grid-cols-3 dark:text-white sm:p-8">
              <div className="flex flex-col items-center justify-center">
                <dt className="mb-2 text-3xl font-extrabold">24 Years</dt>
                <dd className="text-gray-500 dark:text-gray-400">Experience</dd>
              </div>
              <div className="flex flex-col items-center justify-center">
                <dt className="mb-2 text-3xl font-extrabold">20k+</dt>
                <dd className="text-gray-500 dark:text-gray-400">
                  Satisfied Customers
                </dd>
              </div>
              <div className="flex flex-col items-center justify-center">
                <dt className="mb-2 text-3xl font-extrabold">15k+</dt>
                <dd className="text-gray-500 dark:text-gray-400">
                  Customized Orders
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
      <div>
        <h1 className='font-bold text-3xl py-2 text-center'>Gallery</h1>
        <Gallery />
      </div>
    </div>
  );
};

export default AboutInfo;
